module.exports = __webpack_public_path__ + "static/media/CD.11cf4920.svg";